import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home'
import recetas from '@/components/views/listado-recetas'
import ficharecetas from '@/components/views/ficha-receta'
import finconcursoNavidad from '@/components/views/fin-concurso-navidad'
import Error404 from '@/components/views/error-404'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: "Espárragos Carretilla, Calidad desde 1875",
      description: "Referentes en la elaboración de espárragos. Deliciosos espárragos de textura tierna y sin hebras. ¡Descubre todas las recetas con espárragos!"
    }
  },
  {
    path: '/concurso-navidad',
    name: 'concursoNavidad',
    component: finconcursoNavidad,
    meta: {
      title: "Concurso Navidad",
      description: "Para participar solo tienes que dejar el mensaje con el que quieres personalizar la tarjeta de Navidad y la persona a la que te gustaría que se la enviáramos; una madre, un amor, tu amigo de la infancia…"
    }
  },
  {
    path: '/recetas',
    component: recetas,
    meta: {
      title: "Recetas con espárragos Carretilla.",
      description: "Conoce todas las recetas que puedes hacer con los espárragos Carretilla.  Aperitivos, recetas veganas, cocina fácil , para disfrutar en familia…¡descúbrelas!"
    }
  },
  {
    path: `/recetas/:id`,
    component: ficharecetas,
    meta: {
      title: "",
      description: "The purpose of CoordiNet is establish different collaboration schemes between transmission system operators (TSOs), distribution system operators (DSOs) and consumers to contribute to the development of a smart, secure and more resilient energy system."
    }
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/recipes',
    redirect: '/recetas'
  },
  {
    path: "/404",
    component: Error404
  }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
});

router.beforeEach((to, from, next) => {
  let meta;

  if (!!to.meta.title) {
    meta = to.meta;
  } else {
    meta = false;
  }

  if (!!meta) {
    document.title = meta.title;
    document.head.querySelector("[name=description]").content =
      meta.description;
    document.head.querySelector("[name=title]").content =
      meta.title;

  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js